// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"fbffdffc","43":"116c9052","247":"bb578b08","308":"2c53562d","371":"d820d5e1","503":"3be7e3f0","911":"22f1efed"}[chunkId] + ".chunk.js";
};